import { Alert, Badge, Group } from "@mantine/core";
import { IconAlertTriangle, IconSchool } from "@tabler/icons-react";
import { useIpawsAlertFormCertificate } from "shared/components/ipaws/alert/query";
import { IpawsCertificateType } from "src/gql/graphql";
import { match } from "ts-pattern";

export const IpawsAlertFormConnectionStatus = () => {
    const { data } = useIpawsAlertFormCertificate();

    return (
        <Group ml="auto">
            {match(data?.ipawsCertificate.type)
                .with(IpawsCertificateType.Live, () => (
                    <Alert color="yellow" icon={<IconAlertTriangle size={32} />} title="Live Alert" p="xs" />
                ))
                .with(IpawsCertificateType.Test, () => <Alert color="blue" icon={<IconSchool size={32} />} title="Test Alert" p="xs" />)
                .otherwise(() => (
                    <div />
                ))}
            {match(data?.ipawsCertificate.active)
                .with(true, () => <Badge color="green">Connected</Badge>)
                .with(false, () => <Badge color="red">Disconnected</Badge>)
                .otherwise(() => (
                    <Badge variant="default">No Certificate Selected</Badge>
                ))}
        </Group>
    );
};
